import React from "react";
import {useGoogleLogin} from "@react-oauth/google";
import { useDispatch } from "react-redux";
import { createSetUserDataAction } from "../actions/dataActions";
import { Box } from "@allxsmith/bestax-bulma";

const handleSignIn = async (tokenResponse) => {
    //const dispatch = useDispatch();
    const googleUser = tokenResponse;
    console.log(tokenResponse);
    const tokenBlob = new Blob(
      [JSON.stringify({ access_token: googleUser.access_token }, null, 2)],
      { type: "application/json" }
    );
    const options = {
      method: "POST",
      body: tokenBlob,
      mode: "cors",
      cache: "default"
    };
    fetch("/api/social/google-oauth2", options).then(r => {
      r.json().then(resp => {
        if (resp.token) {
          localStorage.setItem("token", resp.token);
          //dispatch(createSetUserDataAction(googleUser));
          window.location.href = "/";
        }
      });
    });
};

function GoogleLoginButton(){

  const signIn = useGoogleLogin({onSuccess: (tokenResponse) => handleSignIn(tokenResponse)});
  return (
    <Box>
      <h1>Login</h1>
      <button onClick={()=> signIn()}>Sign in with Google</button>
    </Box>
  );
}

export default GoogleLoginButton;
